<h1 mat-dialog-title>Benutzer l&ouml;schen?</h1>
<div mat-dialog-content>
	M&ouml;chten Sie die Benutzer wirklich l&ouml;schen?
</div>
<mat-dialog-actions>
	<button mat-raised-button title="Abbrechen" (click)="cancelDeleteUsersClick_dialog()">Abbrechen</button>
	<button mat-raised-button title="Loeschen" (click)="deleteUsersClick_dialog()">L&ouml;schen</button>
</mat-dialog-actions>